import VendorBrowser from "../marketplace/VendorBrowser";

// Stage 4 — Staging. Marketplace-backed: seller picks a stager from our
// vendor network, AI generates a quote scoped to this property.
//
// Replaces the previous hardcoded tier picker. Quote data persists in
// journey state and feeds the Closing stage's net-proceeds calculation later.

export default function StagingStage({ state, journey, update }) {
  return (
    <>
      <p style={{ color: "#5b7365", fontSize: 14, lineHeight: 1.7, margin: "0 0 14px" }}>
        Pick a stager from our marketplace. AI generates a personalized quote
        based on your property and listing. Cost is billed at close, deducted
        from your proceeds.
      </p>
      <VendorBrowser
        type="stager"
        journey={journey}
        state={state}
        update={update}
        stageId="staging"
      />
    </>
  );
}
